<script lang="ts">
  import { StoryblokComponent, storyblokEditable } from '@storyblok/svelte';
  import { Stack, StackItem } from '@athena-lib/Stack';
  import { InnerPageSection, PageSection } from '@athena-lib/Page';
  import { Grid, GridItem } from '@athena-lib/Grid';
  import clsx from 'clsx';
  import { FullwidthCarousel, FullwidthCarouselItem } from '@athena-lib/Carousel';
  import type { ReferencePageSectionBlock } from '@storyblok-types';
  import { isRichTextEmpty } from '../RichText/types';
  import PageSectionHeading from './shared/PageSectionHeading.svelte';
  import { containerAlignClasses, type Alignment } from './shared/page-section-utils';
  import ImageCard from './ImageCard.svelte';

  const { blok }: { blok: ReferencePageSectionBlock } = $props();
</script>

<PageSection
  id={blok.elementId}
  action={storyblokEditable}
  actionArg={blok}
  ySpace={{ top: blok.topPadding ?? 'medium', bottom: blok.bottomPadding ?? 'medium' }}
  xSpace="none"
  backgroundColor={blok.backgroundColor ?? 'medium'}
  width="full"
>
  <Stack space="xlarge">
    <StackItem>
      <InnerPageSection>
        <Stack space="xlarge">
          {#if blok.headingText || !isRichTextEmpty(blok.description)}
            <StackItem>
              <div
                class={clsx(
                  'flex',
                  containerAlignClasses['desktop'][(blok.desktopAlignment as Alignment) ?? 'left'],
                )}
              >
                <div class="max-w-text-max">
                  <PageSectionHeading
                    headingText={blok.headingText}
                    headingTag={blok.headingTag}
                    headingSize={blok.headingSize}
                    description={blok.description}
                    mobileAlignment={blok.mobileTextAlignment}
                    desktopAlignment={blok.desktopTextAlignment}
                  />
                </div>
              </div>
            </StackItem>
          {/if}
          {#if !blok.desktopEnableSwipe || !blok.mobileEnableSwipe}
            <div
              class={clsx(
                blok.mobileEnableSwipe ? 'hidden' : 'block',
                blok.desktopEnableSwipe ? 'md:hidden' : 'md:block',
              )}
            >
              <StackItem>
                <Grid columns={{ sm: 1, md: 3 }} space="large">
                  {#each blok.imageCards ?? [] as innerBlok (innerBlok._uid)}
                    <GridItem>
                      <StoryblokComponent blok={innerBlok} />
                    </GridItem>
                  {/each}
                </Grid>
              </StackItem>
            </div>
          {/if}
        </Stack>
      </InnerPageSection>
    </StackItem>

    {#if blok.desktopEnableSwipe || blok.mobileEnableSwipe}
      <StackItem>
        <div
          class={clsx(
            blok.mobileEnableSwipe ? 'block' : 'hidden',
            blok.desktopEnableSwipe ? 'md:block' : 'md:hidden',
          )}
        >
          <FullwidthCarousel class="pb-6" space="large">
            {#each blok.imageCards ?? [] as imageCard}
              <FullwidthCarouselItem class="w-4/5 md:w-auto">
                <ImageCard blok={imageCard} />
              </FullwidthCarouselItem>
            {/each}
          </FullwidthCarousel>
        </div>
      </StackItem>
    {/if}
  </Stack>
</PageSection>
